import PropTypes from "prop-types";
import React from "react";

import ListViewFilter from "../containers/ListViewFilter";

const formatButtonLabel = count => {
  if (count === 1) {
    return "Delete 1 policy";
  }
  if (count > 1) {
    return `Delete ${count} policies`;
  }
  return "Delete policies";
};

const ListViewActionBar = ({
  canDelete,
  openDeleteModal,
  selectedCount,
  disableDelete,
  saving,
  selectedOrder,
  selectOrder
}) => (
  <div className="l-listview__action-bar">
    <div className="l-flex-start-centered" style={{ gridArea: "delete" }}>
      {canDelete && (
        <button
          type="button"
          className="u-no-margin--bottom"
          onClick={() => openDeleteModal()}
          disabled={disableDelete || saving}
        >
          {formatButtonLabel(selectedCount)}
        </button>
      )}
    </div>
    <div className="l-flex-spaced-centered" style={{ gridArea: "view-by" }}>
      <button
        className={`u-no-margin--bottom ${
          selectedOrder === "entity" ? "p-button--selected" : ""
        }`}
        type="button"
        onClick={() => selectOrder("entity")}
        onKeyPress={() => selectOrder("entity")}
      >
        View by Groups
      </button>
      <button
        className={`u-no-margin--bottom ${
          selectedOrder === "service" ? "p-button--selected" : ""
        }`}
        type="button"
        onClick={() => selectOrder("service")}
        onKeyPress={() => selectOrder("service")}
      >
        View by Services
      </button>
      <button
        className={`u-no-margin--bottom ${
          selectedOrder === "role" ? "p-button--selected" : ""
        }`}
        type="button"
        onClick={() => selectOrder("role")}
        onKeyPress={() => selectOrder("role")}
      >
        View by Roles
      </button>
    </div>
    <div className="l-flex-end-centered" style={{ gridArea: "filter" }}>
      <ListViewFilter selected={selectedOrder} />
    </div>
  </div>
);

ListViewActionBar.defaultProps = {
  disableDelete: true,
  selectedCount: 0,
  saving: false,
  openDeleteModal: undefined,
  selectOrder: undefined,
  selectedOrder: "entity"
};

ListViewActionBar.propTypes = {
  canDelete: PropTypes.bool.isRequired,
  saving: PropTypes.bool,
  disableDelete: PropTypes.bool,
  selectedCount: PropTypes.number,
  openDeleteModal: PropTypes.func,
  selectOrder: PropTypes.func,
  selectedOrder: PropTypes.oneOf(["entity", "service", "role"])
};

export default ListViewActionBar;
